// Shared module-level flag coordinating chat notifications across the app.
//
// When the full chat UI (ChatApp) is mounted it owns sound/notifications for
// incoming user-chat messages (it knows which session is on screen and can
// suppress the sound for it). When ChatApp is NOT mounted, the app-wide
// GlobalChatNotifications handler takes over so the user is still alerted
// wherever they are in the application.
//
// The two are mutually exclusive on purpose, so a message never double-sounds.

let chatAppMounted = false;

export const setChatAppMounted = (mounted) => {
    chatAppMounted = !!mounted;
};

export const isChatAppMounted = () => chatAppMounted;
